/* compare_side_by_side_icon.svg.js */

"use strict";
module.exports = {
    icon: `    
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22.7 20.5" style="enable-background:new 0 0 22.7 20.5;" xml:space="preserve">
		<style type="text/css">
			.st0{fill:#59595C;}
		</style>
		<path class="st0" d="M8.4,12.3h-6c-1.2,0-2.2-0.9-2.2-2s1-2,2.2-2h6c1.2,0,2.2,0.9,2.2,2S9.6,12.3,8.4,12.3z"/>
		<path class="st0" d="M8.4,6.3h-6c-1.2,0-2.2-0.9-2.2-2s1-2,2.2-2h6c1.2,0,2.2,0.9,2.2,2S9.6,6.3,8.4,6.3z"/>
		<path class="st0" d="M8.4,18.3h-6c-1.2,0-2.2-0.9-2.2-2s1-2,2.2-2h6c1.2,0,2.2,0.9,2.2,2S9.6,18.3,8.4,18.3z"/>
		<path class="st0" d="M20.4,12.3h-5.9c-1.2,0-2.2-0.9-2.2-2s1-2,2.2-2h5.9c1.2,0,2.2,0.9,2.2,2S21.6,12.3,20.4,12.3z"/>
		<path class="st0" d="M20.4,6.3h-5.9c-1.2,0-2.2-0.9-2.2-2s1-2,2.2-2h5.9c1.2,0,2.2,0.9,2.2,2S21.6,6.3,20.4,6.3z"/>
		<path class="st0" d="M20.4,18.3h-5.9c-1.2,0-2.2-0.9-2.2-2s1-2,2.2-2h5.9c1.2,0,2.2,0.9,2.2,2S21.6,18.3,20.4,18.3z"/>
	</svg>
         `,
};
